export default __webpack_public_path__ + "static/media/hair-salon.ed3f010b.jpg";